import * as tslib_1 from "tslib";
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import PropTypes from "prop-types";
import { useTheme } from "./Theme/Providers";
export var useResponsiveContainerPadding = function () {
    var _a;
    var theme = useTheme();
    return css((_a = {
            padding: "0 " + theme.spaces.md
        },
        _a[theme.mediaQueries.lg] = {
            padding: "0 " + theme.spaces.lg
        },
        _a));
};
export var Container = function (props) {
    var responsiveContainerPadding = useResponsiveContainerPadding();
    return (jsx("div", tslib_1.__assign({ css: [
            {
                width: "100%",
                maxWidth: "1200px",
                boxSizing: "border-box",
                margin: "0 auto"
            },
            responsiveContainerPadding
        ] }, props)));
};
Container.propTypes = {
    children: PropTypes.node
};
export function NegativeMarginsContainer(props) {
    var _a;
    var theme = useTheme();
    return (jsx("div", tslib_1.__assign({ css: (_a = {
                marginLeft: "-" + theme.spaces.md,
                marginRight: "-" + theme.spaces.md
            },
            _a[theme.mediaQueries.lg] = {
                marginLeft: "-" + theme.spaces.lg,
                marginRight: "-" + theme.spaces.lg
            },
            _a) }, props)));
}
